import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { IEditFile } from '@app-root-interfaces';
import { select } from '@ngrx/store';
import { FormGroup } from '@angular/forms';
import { documentSelectors, documentActions, authSelectors, configSelectors } from '@app-root-store';
import { takeUntil, map, distinctUntilKeyChanged, debounceTime, filter } from 'rxjs/operators';
import { LanguageOptions } from './language-options.config';
import { UploadSidenavComponent } from '../upload-sidenav/upload-sidenav.component';

@Component({
    selector: 'app-edit-sidenav',
    templateUrl: './edit-sidenav.component.html',
    styleUrls: ['./edit-sidenav.component.scss', '../upload-sidenav/upload-sidenav.component.scss'],
    standalone: false
})
export class EditSidenavComponent extends UploadSidenavComponent implements OnInit, OnDestroy {
    public selectedFile$: Observable<IEditFile> = this.store$.pipe(select(documentSelectors.selectDocumentToEdit));

    private token$ = this.store$.pipe(select(authSelectors.selectAuthIdentityToken));

    public loading$: Observable<boolean> = this.store$.pipe(select(documentSelectors.selectDocumentEditLoading));

    public orgUnitList$: Observable<string[]> = this.store$.pipe(
        select(configSelectors.selectOrgUnitList),
        map((orgUnitList: string[]) => orgUnitList.sort())
    );

    protected fileChanges$: Observable<IEditFile> = this.selectedFile$.pipe(
        filter((file) => !!file),
        distinctUntilKeyChanged('id')
    );

    public token = '';

    public uploadForm: FormGroup;

    get languageOptions() {
        return LanguageOptions;
    }

    ngOnInit() {
        super.ngOnInit();

        this.token$.pipe(takeUntil(this.destroy$)).subscribe((token) => (this.token = token));
    }

    public resetActiveFile() {
        this.store$.dispatch(documentActions.cancelEditFile());
    }

    public addPreview(files: FileList) {
        if (files.length === 1) {
            const url = URL.createObjectURL(files.item(0));
            const name = files.item(0).name;
            const size = files.item(0).size;
            const type = files.item(0).type;
            this.store$.dispatch(documentActions.updatePreview({ preview: { url, name, size, type } }));
        } else {
            this.toastNotificationService.queueToastNotification('warning', '', 'Please upload only one file.');
        }
    }

    public addFile(event: Event) {
        const file = (event.target as HTMLInputElement).files;
        if (file.length === 1) {
            const url = URL.createObjectURL(file.item(0));
            const name = file.item(0).name;
            const size = file.item(0).size;
            const type = file.item(0).type;
            this.store$.dispatch(documentActions.editFile({ file: { url, name, size, type } }));
        } else {
            this.toastNotificationService.queueToastNotification('warning', '', 'Please upload only one file.');
        }
    }

    public change() {
        this.store$.dispatch(documentActions.updateFile());
    }

    protected subscribeToUserChanges() {
        this.uploadForm.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe((values) => {
            this.store$.dispatch(documentActions.changeFile({ payload: values }));
        });
    }
}
